package kz.dentalcrm.app.data

import kz.dentalcrm.app.core.utils.Result
import kz.dentalcrm.app.data.network.PositionsApi
import kz.dentalcrm.app.data.network.response_model.positions.Position
import kz.dentalcrm.app.domain.PositionsRepository

class PositionsRepositoryImpl(
    private val positionsApi: PositionsApi
) : PositionsRepository {
    override suspend fun getPositions(): Result<List<Position>> = positionsApi.getPositions()

    override suspend fun addPosition(name: String, description: String): Result<Any?> =
        positionsApi.addPosition(name, description)

    override suspend fun deletePosition(id: Int): Result<Any?> =
        positionsApi.deletePosition(id)

    override suspend fun editPosition(id: Int, name: String, description: String): Result<Any?> =
        positionsApi.updatePosition(id, name, description)
}
